export default __webpack_public_path__ + "static/media/image-boxed-water.9348f4ac.jpg";